<template>
  <button
    class="chips-item"
    type="button"
    :class="[{ '--active': isActive }, `chips-item--${platform}`, { '--disabled': disabled }]"
  >
    <img v-if="customIcon" class="chips-item__custom-icon" :src="customIcon" alt="" />
    <icon v-if="item.icon && !item.iconRight" class="chips-item__icon" :name="item.icon" />
    {{ typeof item === 'string' ? item : item.name }}
    <div v-if="item.amount" class="chips-item__amount">{{ item.amount }}</div>
    <icon v-if="item.icon && item.iconRight" class="chips-item__icon" :name="item.icon" />
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  activeChip: {
    type: Object,
    default: null,
  },
  customIcon: {
    type: [String, null, undefined],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const platform = process.env.PLATFORM

const isActive = computed(() => {
  if (props.item.active) {
    return true
  }

  if (!props.activeChip) {
    return false
  }
  return props.item.id === props.activeChip?.id
})
</script>

<style lang="scss">
.chips-item {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 8px 16px;
  border-radius: 27px;
  background: var(--platform-bg-4);
  border: 1px solid transparent;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: var(--night-gray-900, rgba(255, 255, 255, 0.9));
  cursor: pointer;
  transition:
    color 0.2s ease,
    background 0.2s ease;
  white-space: nowrap;
  &.--disabled {
    pointer-events: none;
  }
  .olimpbet & {
    background: var(--button-secondary-1);
    color: var(--button-secondary);
    &.--active {
      background: var(--button-green-500-20);
      border: 1px solid var(--button-green-300);
      color: var(--button-green-1000);
    }
    &:not(.--active):hover {
      background: var(--button-green-500-20);
    }
  }
  &:not(.--active) {
    &:hover {
      background: var(--night-gray-300, rgba(255, 255, 255, 0.28));
    }
    &:active {
      background: var(--night-gray-500, rgba(255, 255, 255, 0.47));
    }
  }

  &__icon {
    height: 16px;
    width: 16px;
    font-size: 16px;
    flex-shrink: 0;
  }

  &__custom-icon {
    max-width: 24px;
    max-height: 24px;
  }

  &__amount {
    color: var(--night-gray-700, rgba(255, 255, 255, 0.7));
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--night-gray-100, rgba(255, 255, 255, 0.07));
    border: 1px solid var(--night-gray-200, rgba(255, 255, 255, 0.14));
    border-radius: 9px;
  }

  &.--active {
    background: var(--cas-secondary-20);
    border: 1px solid var(--cas-secondary);
  }
}
</style>
